const stripHtmlToPlainText = (html) => {
  if (!html || typeof html !== "string") return "";

  const decoded = html
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

  return decoded.replace(/\s+/g, " ").trim();
};

const isReadMoreEnabled = (readMoreFlag) =>
  readMoreFlag === true || readMoreFlag === "true";

/**
 * Show "Read More" when the backend says more content exists.
 * Do not gate on truncated snippet length — feed payloads are already shortened
 * (often under ~280 chars) while readMore remains true.
 */
export const shouldShowPostReadMore = (postContent, readMoreFlag) => {
  if (!isReadMoreEnabled(readMoreFlag)) return false;

  const plainText = stripHtmlToPlainText(postContent);
  return plainText.length > 0;
};

export default shouldShowPostReadMore;
